import { render, staticRenderFns } from "./ConfigureCertificate.vue?vue&type=template&id=c966c6d8"
import script from "./ConfigureCertificate.vue?vue&type=script&lang=js"
export * from "./ConfigureCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports